export const routes = {
  Signup: () => '/signup/:token',
  Login: () => '/login',
  Projects: () => '/projects',
  ProjectAdd: () => `/projects/add`,
  ProjectEdit: (id: number | string = ':id') => `/projects/edit/${id}`,
  Members: () => '/members',
  Teams: () => '/teams',
  PasswordRecovery: () => '/passwordRecovery',
  PasswordReset: () => '/redefinePassword/:token',
  EditAccount: () => '/editAccount',
  EditName: () => '/editAccount/name',
  UserConfirm: () => '/confirm/:type/:token',
  Folders: () => '/folders',
  Maps: () => `/maps`,
  DiagnosesCompare: (projectId = ':projectId', regionId = ':regionId') =>
    `/maps/compare/${projectId}/${regionId}`,
  Diagnoses: () => '/diagnoses',
  DiagnosisView: (
    companyId = ':companyId',
    culture = ':culture',
    treatment = ':treatment',
    id = ':id',
  ) => `/diagnoses/${companyId}/${culture}/${treatment}/${id}`,
  Demands: (state = ':state') => `/diagnoses/new/${state}`,
  EditDiagnosis: (step = ':step', id = ':id') =>
    `/diagnoses/edit/${step}/${id}`,
  DemandAnalysis: (
    companyId = ':companyId',
    culture = ':culture',
    treatment = ':treatment',
    diagnosisId = ':diagnosisId',
    step = ':step',
  ) =>
    `/diagnoses/${companyId}/${culture}/${treatment}/${diagnosisId}/reported/${step}`,
  Reports: (type = ':type') => `/reports/${type}`,
  Activities: () => '/calendar/activities',
  ActivityAdd: () => '/calendar/activities/add',
  ConfirmPulverizationActivity: (activityId = ':activityId') =>
    `/calendar/activities/${activityId}/pulverization`,
}

export const defaultRoute = routes.Diagnoses

export const publicRoutesList = [
  routes.Signup(),
  routes.Login(),
  routes.PasswordRecovery(),
  routes.PasswordReset(),
  routes.UserConfirm(),
]
export const privateRoutesList = [
  routes.Projects(),
  routes.ProjectAdd(),
  routes.ProjectEdit(),
  routes.Members(),
  routes.Teams(),
  routes.EditAccount(),
  routes.EditName(),
  routes.Folders(),
  routes.Diagnoses(),
  routes.EditDiagnosis(),
  routes.DiagnosisView(),
  routes.Demands(),
  routes.DemandAnalysis(),
  routes.Reports(),
  routes.Activities(),
  routes.ActivityAdd(),
  routes.ConfirmPulverizationActivity(),
  routes.Maps(),
  routes.DiagnosesCompare(),
]
export const userRoutesList = [routes.EditAccount(), routes.EditName()]
